import { formatNumber } from "helpers/system";
import { divIcon } from "leaflet";
import React, { useEffect } from "react";
import { Marker, Popup } from "react-leaflet";

const PointPrediction = (props) => {
    const {
        addressInfo: { address, location },
        probability,
        bidPointId,
        changeMapPosition,
        mergeMapData,
        currentBid,
        updatePoint,
    } = props;
    useEffect(() => {
        changeMapPosition([[...location.coordinates].reverse()], 8);
    }, []);
    const initMarker = (ref) => {
        if (ref) {
            setTimeout(() => {
                ref.openPopup();
            }, 0);
        }
    };
    const changePoint = () => {
        mergeMapData({ compareBid: currentBid, isLoading: true });
        updatePoint(props.addressInfo, bidPointId).then(() =>
            mergeMapData({ compareBid: currentBid, pointPrediction: null, isLoading: false }),
        );
    };
    return (
        <Marker
            ref={initMarker}
            position={[...location.coordinates].reverse()}
            icon={divIcon({
                iconSize: [28, 82],
                className: "map__icon map-icon map-icon--point-prediction map-icon--car",
            })}
        >
            <Popup className="map__popup" autoPan={false} closeOnClick={false} closeButton={false}>
                <div className="p-2">
                    <div className="pb-3 font-size-14">
                        {probability && (
                            <div className="pb-1">
                                С вероятностью <b>{formatNumber(probability)}%</b> система определила точку выгрузки:
                            </div>
                        )}
                        <div className="pb-1">
                            <small className="text-muted">{address}</small>
                        </div>
                        Изменить точку выгрузки?
                    </div>
                    <div className="d-flex justify-content-between">
                        <div
                            className="btn btn-xs btn-secondary"
                            onClick={() => mergeMapData({ compareBid: currentBid, pointPrediction: null })}
                        >
                            Отменить
                        </div>
                        <div className="btn btn-xs btn-brand" onClick={changePoint}>
                            Изменить
                        </div>
                    </div>
                </div>
            </Popup>
        </Marker>
    );
};

export default PointPrediction;
